export const getPageEpsIdObject = (object, listEps) => {
    const matchingEps = listEps.find((eps) => {
        const entities = [...eps.textsEps, ...eps.circularTextsEps, ...eps.imagePlaceHoldersEps, ...eps.vectorEPSEps];
        return entities.some((entity) => entity.uuid === object.uuid);
    });

    if (matchingEps) {
        return matchingEps.id;
    }
    return null;
};

export const getPageEpsIdGroupEps = (group, groupsEps) => {
    if (group.pageEpsId) return group.pageEpsId;
    const groupEps = groupsEps.find((g) => g.uuid === group.uuid);
    if (groupEps) return groupEps.pageEpsId;
    return null;
};

export const updatePageEpsVisibilityAndLocked = (canvas) => {
    if (!canvas) return;
    const listPageEps = canvas.getElementsPageEps();
    for (const page of listPageEps) {
        const elements = canvas.getPageEpsElements(page);
        const isVisible = elements.some((element) => element.visible);
        page.locked = false;
        if (page.visible !== isVisible) page.visible = isVisible;
    }
    canvas.fire('pageeps:update');
};

export const getObjectsPageEps = (eps) => {
    const {textsEps = [], circularTextsEps = [], imagePlaceHoldersEps = [], vectorEPSEps = []} = eps;
    const objects = [
        ...textsEps,
        ...circularTextsEps,
        ...imagePlaceHoldersEps,
        ...vectorEPSEps
    ];
    return objects;
}